import { render, staticRenderFns } from "./CockpitOverview.vue?vue&type=template&id=6801e842"
import script from "./CockpitOverview.vue?vue&type=script&lang=js"
export * from "./CockpitOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports